import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { Modal } from 'semantic-ui-react';

import StatefulModal from 'Components/Modal/StatefulModal';
import CreateEditForm from 'Containers/CreateEditForm';

import { getCollections, getCollection } from '../../GraphQL/query/Products.query';
import {
  createCollectionMutation,
  updateCollectionMutation,
} from '../../GraphQL/mutation/Products.mutation';

import CollectionForm from './CollectionForm';

export default class CollectionModal extends Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    id: PropTypes.string,
    trigger: PropTypes.element,
  };
  static defaultProps = {
    isEdit: false,
  };

  render() {
    const { isEdit, id, trigger, variables } = this.props;
    return (
      <StatefulModal trigger={trigger} dimmer="inverted">
        {(closeModal) => (
          <Fragment>
            <Modal.Header>{isEdit ? 'Edit Collection' : 'Create Collection'}</Modal.Header>
            <Modal.Content>
              <CreateEditForm
                dataQuery={getCollection}
                createMutation={createCollectionMutation}
                createRefetchQueries={[
                  {
                    query: getCollections,
                    variables,
                  },
                ]}
                editMutation={updateCollectionMutation}
                isEdit={isEdit}
                id={id}
                getQueryVariables={({ id }) => ({
                  id,
                })}
                getEditVariables={(form, { id }) => ({
                  id,
                  data: { ...form },
                })}
                getCreateVariables={(form) => ({
                  data: { ...form },
                })}
                onCompleted={closeModal}
                onCancelled={closeModal}
              >
                {({ data, onSubmit }) => {
                  return (
                    <CollectionForm
                      initialData={data && data.sfBoProductCollection}
                      onSubmit={onSubmit}
                    />
                  );
                }}
              </CreateEditForm>
            </Modal.Content>
          </Fragment>
        )}
      </StatefulModal>
    );
  }
}
